import { RegistriaUsersResponse } from '../../models/registria/registria-users-response.interface';
import { mockRegistriaSnippetResponse } from './registria-snippet-response.mock';

export const mockRegistriaUsersResponse: RegistriaUsersResponse = {
  sessionId: '1234567890',
  snippet_data: mockRegistriaSnippetResponse,
};
